export default __webpack_public_path__ + "b2ffda006a33beebc3b3c28651724748.csv";